import React, { useEffect, useState } from 'react'
import { getCookie } from 'typescript-cookie'
import { Buffer } from 'buffer'

export const useApiKey = (
  refresh: any = undefined,
  delay = 100
) => {
  const [token, setToken] = useState({
    data: undefined,
    error: undefined
  })

  const getTokenFromCookie = () => {
    const value = getCookie('pollination-authz')
    if (value) {
      const base64string = value.replace(/_/g, '/').replace(/-/g, '+')
      const buffer = Buffer.from(base64string, 'base64')
      if (buffer) {
        const innerBase64 = buffer.toString('utf-8')?.split('|')[1]
        if (!innerBase64) return
        const cookiePayloadString = Buffer.from(innerBase64, 'base64')?.toString('utf-8')

        try {
          const cookiePayload = JSON.parse(cookiePayloadString)
          setToken({
            data: cookiePayload.api_token,
            error: undefined
          })
        } catch (error) {
          setToken({
            data: undefined,
            error: {
              message: 'Authentication failed. The pollination-authz cookie does not contain an API Token. Try the useToken hook instead.'
            }
          })
        }
      }
    }
  }

  useEffect(() => {
    const handler = setTimeout(getTokenFromCookie, delay)
    return () => clearTimeout(handler)
  }, [refresh, delay])

  return token
}